import { render, staticRenderFns } from "./AddUpdateCoupons.vue?vue&type=template&id=4886d4eb&scoped=true&"
import script from "./AddUpdateCoupons.vue?vue&type=script&lang=js&"
export * from "./AddUpdateCoupons.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateCoupons.vue?vue&type=style&index=0&id=4886d4eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886d4eb",
  null
  
)

export default component.exports